import Vue from 'vue';
import App from './App.vue';
import TRTC from 'trtc-js-sdk';
import '@/utils/aegis.js';
import '@/assets/style/global.css';
import '@/assets/style/reset.scss';
import '@/assets/icons';
import '@/assets/style/theme/index.css';
import { isMobile } from '@/utils/utils';
import store from './store'
import api from '@/services'

import {
  Collapse,
  CollapseItem,
  Select,
  Option,
  Input,
  Button,
  Message,
  MessageBox,
  Tooltip,
  Alert,
  Form,
  FormItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Loading,
  Notification,
  Empty
} from 'element-ui';

import router from './router';
import i18n from './locales/i18n';

/**
 *  重写ElementUI的Message
 */
const showMessage = Symbol('showMessage');
class DonMessage {
  success(options, single = true) {
    this[showMessage]('success', options, single);
  }
  warning(options, single = true) {
    this[showMessage]('warning', options, single);
  }
  info(options, single = true) {
    this[showMessage]('info', options, single);
  }
  error(options, single = true) {
    this[showMessage]('error', options, single);
  }
  [showMessage](type, options) {
    Message[type](options);
  }
}
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Alert);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Empty);
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = new DonMessage();
Vue.prototype.$notify = Notification;
Vue.prototype.$isMobile = isMobile;
Vue.prototype.$api = api
Vue.config.productionTip = false;

TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.DEBUG);
new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
